import moment from 'moment';
import { PACKAGE_HAS_EOL } from '@src/constants/package';
import { VOICE_LEVEL, VOICE_PROVIDER } from '@src/constants/voice';

const extractVoiceName = ({ name = '', provider = '' }) => {
  if (provider === VOICE_PROVIDER.VBEE)
    return { voiceName: name.split(' - ')[1] };
  if (name.includes(' - ')) {
    const [voiceName, voiceType] = name.split(/-(?=[^-]*$)/);
    return { voiceName, voiceType };
  }

  return { voiceName: name };
};

const checkAdvancedGlobalVoice = (voice) => {
  if (!voice) return false;

  const isGlobalVoice =
    voice.provider &&
    ![VOICE_PROVIDER.VBEE, VOICE_PROVIDER.VBEE_VOICE_CLONING].includes(
      voice.provider,
    );

  return voice.level === VOICE_LEVEL.ADVANCED && isGlobalVoice;
};

const canUseEOLVoice = ({ voice, user }) => {
  const voiceEOLDate = voice?.eolDate;
  const userEOLDate = user?.studio?.oneTime?.eolDate;
  const oneTimePackageCode = user?.studio?.oneTime?.packageCode;
  const oneTimeRemainingCharacters = user?.remainingCharacters;

  if (
    !voiceEOLDate ||
    !userEOLDate ||
    !oneTimePackageCode ||
    !oneTimeRemainingCharacters
  )
    return false;

  const latestEOLDate = new Date(
    Math.max(new Date(voiceEOLDate).getTime(), new Date(userEOLDate).getTime()),
  );

  const isAfterEOL = moment().isAfter(latestEOLDate);
  if (isAfterEOL) return false;

  return PACKAGE_HAS_EOL.includes(oneTimePackageCode);
};

export { extractVoiceName, checkAdvancedGlobalVoice, canUseEOLVoice };
